import { Chip, ChipColor, ChipSize } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { dayjs } from "@outschool/time";
import React from "react";

import * as Section from "../../../shared/Section";

interface SectionStatusChipProps {
  size?: ChipSize;
  section: {
    start_time: any;
    end_time: any;
    deleted_at: any;
    canceled_at: any;
    published_at: any;
  };
}

export const SectionStatusChip: React.FunctionComponent<
  SectionStatusChipProps
> = ({ size, section }) => {
  const { t } = useTranslation("client\\components\\Chips\\SectionStatusChip");

  const isInProgress = Section.isInProgress(section);
  const isComplete = Section.isComplete(section);
  const isCanceled = Section.isCanceled(section);
  const startOfNextWeek = dayjs().utc().add(1, "week").startOf("isoWeek");
  const endOfNextWeek = dayjs().utc().add(2, "weeks").startOf("isoWeek");
  const startsNextWeek = dayjs(section.start_time).isBetween(
    startOfNextWeek,
    endOfNextWeek,
    "day",
    "[)",
  );

  let label: string;
  let color: ChipColor;

  if (isComplete) {
    label = t("Completed");
    color = "neutral";
  } else if (isCanceled) {
    label = t("Canceled");
    color = "error";
  } else if (isInProgress) {
    label = t("In Progress");
    color = "success";
  } else if (startsNextWeek) {
    label = t("Starts Next Week");
    color = "info";
  } else {
    label = t("Upcoming");
    color = "primary";
  }

  return <Chip label={label} size={size} color={color} />;
};
